import { GroupChannel } from "@sendbird/chat/groupChannel";
import {
  formatShortMonthDayYear,
  formatTime,
  isToday,
  isYesterday,
} from "@clipboard-health/date-time";

export function getLastMessageDate(channel: GroupChannel, timeZone: string) {
  const lastMessageTimestamp = channel.lastMessage?.createdAt ?? channel.createdAt;
  const lastMessageDate = new Date(lastMessageTimestamp);

  if (isToday(lastMessageDate, { timeZone })) {
    return formatTime(lastMessageDate, { timeZone });
  }

  if (isYesterday(lastMessageDate, { timeZone })) {
    return "Yesterday";
  }

  return formatShortMonthDayYear(lastMessageDate, { timeZone });
}
